import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, theme } from '@olxbr/design-system'
import contentStyle from './style'
import Svg from '../../atoms/Svg'
import Touchable from '../../atoms/Touchable'
import chevronRightSvgPath from '../../../assets/icons/chevronRight'

const Content = styled(View)`
  ${contentStyle}
`

const HelpFooter = props => (
  <Touchable onClick={props.onClick}>
    <Content>
      <span className="typo-body-small">Preciso de ajuda</span>
      <Svg
        width={16}
        height={16}
        svgPath={chevronRightSvgPath}
        color={theme.colors.dark}
        viewBox="0 0 24 24"
      />
    </Content>
  </Touchable>
)

HelpFooter.propTypes = {
  onClick: PropTypes.func,
}

export default HelpFooter
